import * as React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useVehicles } from '@/modules/shared/context/vehicles/VehiclesContext'
import { ViewModeUi } from '@/modules/drivers/shared/viewBars/ViewModeUi'
import {
  pathForSelectedVehicle,
  pathForVehicleGroup,
} from '../../utils/resolveVehiclePath'

const ViewMode = ({
  blockedView = false,
  padding = false,
  vehicles = false
}: {
  blockedView?: boolean
  padding?: boolean
  vehicles?: boolean
}) => {
  const { activeViewMode, vehiclesIds } = useVehicles()
  const { pathname } = useLocation()
  const { companyId } = useParams<{ companyId: string }>()

  const toggleUrl = React.useMemo(() => {
    if (blockedView || !companyId) return ''
    if (activeViewMode === 'group') {
      if (vehiclesIds.length === 0) return ''
      return pathForSelectedVehicle(pathname, companyId, vehiclesIds[0])
    }
    return pathForVehicleGroup(pathname, companyId)
  }, [activeViewMode, pathname, vehiclesIds, blockedView, companyId])

  return (
    <ViewModeUi
      vehicles={vehicles}
      mode={activeViewMode as 'single' | 'group'}
      toggleUrl={toggleUrl}
      padding={padding}
    />
  )
}

export default ViewMode
